module.exports = __webpack_public_path__ + "img/hr-pipe-cross.0951f715.png";